<div class="form-builder">
    <h2 class="popup-title text-center">{{ project && project['projectName'] ? ('addproject.title2popuptitleedit' |
        translate) : ('addproject.title2popuptitleadd' | translate)}}</h2>
    <app-form-builder [formSchema]="formSchema" typeClass="vertical-form "
        (onSubmit)="formConstructorData($event)"></app-form-builder>
</div>